import React from 'react';

const STAT_CONFIG = [
  {
    key: 'products',
    label: 'Total Products',
    description: 'Products registered in your firm',
    icon: '▦',
    color: 'blue',
  },
  {
    key: 'batches',
    label: 'Total Batches',
    description: 'Batches recorded',
    icon: '▤',
    color: 'purple',
  },
  {
    key: 'invoices',
    label: 'Total Invoices',
    description: 'Invoices created',
    icon: '▧',
    color: 'orange',
  },
  {
    key: 'stock',
    label: 'Stock Items',
    description: 'Inventory overview',
    icon: '▥',
    color: 'green',
  },
];

const UserDashboardStats = ({
  stats = {},
  loading = false,
}) => {
  return (
    <section
      className="user-dashboard-stats"
      aria-label="Inventory statistics"
    >
      {STAT_CONFIG.map((item) => {
        const value = stats[item.key];

        return (
          <article
            key={item.key}
            className="user-stat-card"
          >
            <div className="user-stat-card-top">
              <div>
                <p className="user-stat-label">
                  {item.label}
                </p>

                <h3 className="user-stat-value">
                  {loading
                    ? '...'
                    : value == null
                      ? '—'
                      : Number(value).toLocaleString()}
                </h3>
              </div>

              <div
                className={`user-stat-icon ${item.color}`}
                aria-hidden="true"
              >
                {item.icon}
              </div>
            </div>

            <p className="user-stat-description">
              {item.description}
            </p>
          </article>
        );
      })}
    </section>
  );
};

export default UserDashboardStats;